import React, { useState, useEffect, ReactNode } from 'react';
import Parse from 'html-react-parser';

import './index.css';

export type Position = 'fullLeft' | 'left' | 'right' | 'fullRight' | 'top' | 'center';

interface Props {
  value: string,
  options: {
    left: { label: string, value: string },
    right: { label: string, value: string }
  },
  onChange: Function,
  title?: string,
  name?: string,
  disabled?: boolean
  tooltip?: ReactNode
  tooltipPosition?: Position,
  tooltipColor?: string,
}

const HHTextToggle: React.FC<Props> = (props) => {

  const [clickActive, setClickActive] = useState<boolean>(false);

  useEffect(() => {
    setClickActive(false);
  }, [])

  const handleClick = () => {
    props.onChange({
      target: {
        name: props.name,
        value: props.value === props.options.left.value ? props.options.right.value : props.options.left.value
      }
    }
    );
  }

  return (
    <div className="hh-toggle" onClick={handleClick}>
      {
        props.title &&
        <div className="title">{props.title}</div>
      }
      <span>{props.options.left.label}</span>
      <div className={`content ${props.value === props.options.left.value ? "left" : "right"}`}>
        <div className="dot" />
      </div>
      <span>{props.options.right.label}</span>
      {
        props.tooltip && clickActive === false &&
        <div className="tooltip">
          <div className="body">
            <div className={`content ${props.tooltipPosition || ''}`} style={{ backgroundColor: props.tooltipColor }}>
              {
                (typeof props.tooltip === 'string')
                  ? <span>{props.tooltip}</span>
                  : props.tooltip
              }
            </div>
            <span className="arrow" style={{ backgroundColor: props.tooltipColor }} />
          </div>
        </div>
      }
    </div>

  );
}

export default HHTextToggle;